import { createConfirmation } from "react-confirm";
import AddProductDialog from "./AddProductDialog";

export const showAddProductDialog = createConfirmation(AddProductDialog);
